import { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { loadCars } from '@/modules/car/actions/async/loadCars';
import { getCars } from '@/modules/car/store/selectors';
import { AppDispatch } from '@/root-store';

import { View } from './view';

interface IProps {
  onNavigate: (url: string) => void;
}

const CarList = ({ onNavigate }: IProps) => {
  const dispatch: AppDispatch = useDispatch();

  usePermissions('viewCars');

  const cars = useSelector(getCars);
  const [isLoading, setIsLoading] = useState(false);

  const handleClickNew = useCallback(() => {
    onNavigate('/add-vehicle');
  }, [onNavigate]);

  const fetchCars = useCallback<React.ComponentProps<typeof View>['fetchCars']>(
    async (_, { limit, offset }) => {
      setIsLoading(true);

      try {
        await dispatch(loadCars({ limit, offset })).unwrap();
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, setIsLoading],
  );

  return (
    <View fetchCars={fetchCars} cars={cars} onClickNew={handleClickNew} isLoading={isLoading} />
  );
};

export { CarList };
